import React, { useState } from "react";
import Box from "@mui/material/Box";
import Header from "../Components/Header";
import HomeIcon from "@mui/icons-material/Home";
import GroupIcon from "@mui/icons-material/Group";
import SettingIcon from "@mui/icons-material/Settings";
import SNETFooter from "shared/dist/components/SNETFooter";
import VerticalTabs from "shared/dist/components/VerticalTabs";
import MyDaemonsIcon from "../Components/HaaS/Assets/MyDaemonsIcon";
import HostingUnavailable, {
    isHostingAvailable as getHostingAvailability,
} from "../Components/HaaS/Components/HostingUnavailable";
import { GlobalRoutes } from "../GlobalRouter/Routes";
import { FooterData } from "./footerContent";
import { useSelector } from "react-redux";
import { useStyles } from "./styles";
import { navigate } from "../Utils";

const isHostingAvailable = getHostingAvailability();

const withDashboardMenu = (Component) => {
    const ComponentWithDashboardMenu = (props) => {
        const [isHostingUnavailableModalOpen, setIsHostingUnavailableModalOpen] = useState(false);
        const orgUuid = useSelector((state) => state.organization.uuid);

        const getTabRoute = (route) => {
            return orgUuid ? route : GlobalRoutes.LOGIN.path;
        };

        const navigateToDaemonsPage = () => {
            if (!isHostingAvailable) {
                return () => setIsHostingUnavailableModalOpen(true);
            }

            return () => navigate(GlobalRoutes.MY_DAEMONS.path.replace(":orgUuid", orgUuid));
        };

        const closeHostingUnavailableModal = () => {
            setIsHostingUnavailableModalOpen(false);
        };

        const upperTabs = [
            {
                icon: <HomeIcon />,
                title: "My AI Apps",
                onRowClick: () =>
                    navigate(getTabRoute(GlobalRoutes.SERVICES.path.replace(":orgUuid", orgUuid))),
            },
            {
                icon: <MyDaemonsIcon />,
                title: "My Daemons",
                onRowClick: navigateToDaemonsPage(),
            },
            {
                icon: <GroupIcon />,
                title: "Teams & Access",
                onRowClick: () =>
                    navigate(
                        getTabRoute(GlobalRoutes.INVITE_MEMBERS.path.replace(":orgUuid", orgUuid))
                    ),
                openInNewTab: false,
            },
        ];

        const lowerTabs = [
            {
                icon: <SettingIcon />,
                title: "Settings",
                href: getTabRoute(GlobalRoutes.USER_PROFILE.path),
                openInNewTab: false,
            },
        ];

        const classes = useStyles();

        return (
            <Box>
                <Header />
                <Box>
                    <VerticalTabs upperTabs={upperTabs} lowerTabs={lowerTabs} />
                    <Box
                        className={`${classes.componentsContainer} ${classes.dashboardContainers}`}
                    >
                        <Component {...props} />
                    </Box>
                </Box>
                {isHostingUnavailableModalOpen && (
                    <HostingUnavailable onClose={closeHostingUnavailableModal} />
                )}
                <SNETFooter data={FooterData} />
            </Box>
        );
    };

    return ComponentWithDashboardMenu;
};

export default withDashboardMenu;
